import {AnyAction} from "redux";
import {TOGGLE_DEBUG_CONSOLE} from "../action";


/**
 * show the debug console
 * @return {{type: string, payload: {visible: boolean}}}
 */
export function showDebugConsole() : AnyAction
{
    return {type: TOGGLE_DEBUG_CONSOLE, payload: { visible: true }};
}


/**
 * show the debug console
 * @return {{type: string, payload: {visible: boolean}}}
 */
export function hideDebugConsole() : AnyAction
{
    return {type: TOGGLE_DEBUG_CONSOLE, payload: { visible: false }};
}

/**
 * toggle the debug console
 * @return {{type: string, payload: {visible: boolean}}}
 */
export function toggleDebugConsole(visible: boolean) : AnyAction
{
    return {type: TOGGLE_DEBUG_CONSOLE, payload: {visible}};
}


// WEBPACK FOOTER //
// ./src/ts/store/actions/debug-console/visible.ts